export const timeEntityButtonTestId = 'timeEntityButtonTestId';
